import * as React from 'react';
export var IconMenuFill = React.forwardRef(function IconMenuFill({ size = 24, ...other }, ref) {
    if (size === 16 || size === '16') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-sm': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M3 3.75A.75.75 0 0 1 3.75 3h8.5a.75.75 0 0 1 0 1.5h-8.5A.75.75 0 0 1 3 3.75Zm0 8a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75ZM3.75 7a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z',
            fill: 'currentColor',
            'data-global-icon-size-sm': true
        }));
    }
    if (size === 24 || size === '24') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-md': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M6 7a1 1 0 0 1 1-1h10.001a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h10.001a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h10.001a1 1 0 1 0 0-2H7Z',
            fill: 'currentColor',
            'data-global-icon-size-md': true
        }));
    }
    if (size === 32 || size === '32') {
        return /*#__PURE__*/ React.createElement('svg', {
            width: '24',
            height: '24',
            viewBox: '0 0 24 24',
            fill: 'none',
            ref: ref,
            focusable: false,
            ...other,
            'data-global-icon-size-lg': true
        }, /*#__PURE__*/ React.createElement('path', {
            d: 'M6 7a1 1 0 0 1 1-1h10.001a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm0 5a1 1 0 0 1 1-1h10.001a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm1 4a1 1 0 1 0 0 2h10.001a1 1 0 1 0 0-2H7Z',
            fill: 'currentColor',
            'data-global-icon-size-lg': true
        }));
    }
});
